import escapeRegExp from 'lodash/escapeRegExp'

import { Include, Practitioner } from '~/storm'

/**
 * Re-exported for callers that previously typed against both Storm and
 * Denormalizer practitioners. The Denormalizer type is a structural subtype
 * of the Storm one (see §10 of the shallow-selectors docs), so the bare
 * Storm `Practitioner` is sufficient.
 */
export type AnyPractitioner = Practitioner

/**
 * DIPS seems to append the shortName at the end of the fullname.
 *
 * eg. John Doe with ShortName JDO would be "Doe John, (Jdo)"
 * This function will remove the shortname from the full name.
 * Note that this is intentionally quite strict - only removes if fullname contains shortname in parentheses at end of string.
 */
const removeShortnameAtEnd = (fullname: string | undefined | null, shortname: string | undefined | null) => {
    if (!fullname || !shortname) return fullname

    const escapedShortname = escapeRegExp(shortname)
    const regex = new RegExp(`\\(${escapedShortname}\\)$`, 'i')

    return fullname.trim().replace(regex, '').trim()
}

export function getPractitionerFullname(practitioner?: Include<Practitioner, { dipsResource: true }>): string {
    return removeShortnameAtEnd(practitioner?.dipsResource?.name, practitioner?.short_name) ?? practitioner?.short_name ?? ''
}
